import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import StoreInventoryList from './StoreInventoryList.jsx';

const StoreModal = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [addressData, setAddressData] = useState('');
  const [storeList, setStoreList] = useState([]);
  const [sortedStoreList, setSortedStoreList] = useState([]);
  const [loadMoreClicked, setLoadMoreClicked] = useState(false);
  const [numberOfStores, setNumberOfStores] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [firstTimeOpened, setFirstTimeOpened] = useState(false);
  const [formError, setFormError] = useState(false);
  const [successfulResponse, setSuccessfulResponse] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const inventoryThreshold = document.querySelector('[data-inventory-threshold]');
  const inventoryThresholdNumber = Number(inventoryThreshold.dataset.inventoryThreshold);
  const storedLatitude = useRef(false);
  const storedLongitude = useRef(false);
  const searchedOnce = useRef(false);
  const radiusData = useRef(25);
  const savedRadiusData = useRef(25);
  const API_KEY =
    window.location.origin.indexOf('windsorstore.com') > -1
      ? 'AIzaSyAeTZw-ttseoKrNwCEQOjqLEQkX_JFmeuY'
      : 'AIzaSyCQt8mUN8zA2y1ps1UzIPq9Pwg8c9qnkY4';

  // wndsr.dev = AIzaSyDEbOrZnu_--AvK1zJbAiaWl_yqoguqgc8
  // windsorstore.com = AIzaSyAeTZw-ttseoKrNwCEQOjqLEQkX_JFmeuY
  // all environments, no restrictions = AIzaSyCQt8mUN8zA2y1ps1UzIPq9Pwg8c9qnkY4

  // console.log(`Store inventory threshold number: ${inventoryThresholdNumber}`);

  const setDynamicHeight = () => {
    let el = document.querySelector('.StoreInventoryModal__container');

    if (!el) {
      return;
    }

    const modalHeight = document.querySelector('.StoreInventoryModal__container').clientHeight;
    document.querySelector('.StoreInventory').style.height = `${modalHeight}px`;
  };

  useEffect(() => {
    const storeListInventory = [];
    const storeListZeroInventory = [];

    // Sort through store list and prioritize stores with inventory above stores with 0 inventory.
    // Update the store availbility depending on the inventory threshold value
    storeList.forEach((store) => {
      if (store.quantity - inventoryThresholdNumber <= 0) {
        store.quantity = 0;
        storeListZeroInventory.push(store);
      } else {
        storeListInventory.push(store);
      }
    });

    setNumberOfStores(storeListInventory.length);

    // Merge both arrays so stores with availability show before stores with 0 inventory.
    const mergedStoreList = storeListInventory.concat(storeListZeroInventory);
    setSortedStoreList(mergedStoreList);
    // console.log(mergedStoreList);
  }, [storeList]);

  // Click "Check availability" copy and open search modal
  document.querySelector('[data-check-availability]').addEventListener('click', (e) => {
    event.stopImmediatePropagation();
    setModalIsOpen(true);
    dataLayer.push({
      event: 'pdp_local_store_availability_click',
    });

    // On mobile, push product detail section down when opening the search modal
    if (window.innerWidth <= 767) {
      setDynamicHeight();
    }
  });

  const closeModal = () => {
    setModalIsOpen(false);
    if (window.innerWidth <= 767) {
      document.querySelector('.StoreInventory').style.height = 'auto';
    }
  };

  const submitSearch = (e) => {
    e.preventDefault();
  };

  const clickLoadMore = () => {
    setLoadMoreClicked(true);
  };

  const clearLocalStorage = () => {
    window.localStorage.removeItem('userLatLong');
    window.localStorage.removeItem('userAddress');
  };

  const getGeoLocation = () => {
    setSuccessfulResponse(false);
    setFormError(false);
    setErrorMessage('');

    if (addressData === '') {
      setErrorMessage('Oops! Some fields are missing information. Please complete your info and click "GO".');
      setFormError(true);
      return;
    }

    // trigger global event for rtb availability
    document.dispatchEvent(new Event('rtb_availability'));

    const encodedAddress = encodeURI(addressData);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${API_KEY}`;

    // AIzaSyCQt8mUN8zA2y1ps1UzIPq9Pwg8c9qnkY4

    // eslint-disable-next-line promise/always-return
    fetch(url)
      .then((response) =>
        // eslint-disable-next-line promise/always-return
        response.json(),
      )
      .then((data) => {
        // console.log(data.results[0].geometry.location);
        const location = data.results[0].geometry.location;
        storedLatitude.current = location.lat;
        storedLongitude.current = location.lng;
        window.localStorage.setItem(
          'userLatLong',
          JSON.stringify({
            latitude: location.lat,
            longitude: location.lng,
          }),
        );
        window.localStorage.setItem('userAddress', addressData);
        setFirstTimeOpened(true);
        // Create middleaware request that sends coordinates + radius
        fetchStores(location.lat, location.lng, false);
      })
      .catch((error) => {
        console.error('Error:', error);
        setErrorMessage(
          "Oops! We couldn't recognize that address. Please make sure to enter Zip Code or City and State.",
        );
        setFormError(true);
        clearLocalStorage();
      });
  };

  const fetchStores = (latitude, longitude, isGeoLocation) => {
    setIsLoading(true);
    storedLatitude.current = latitude;
    storedLongitude.current = longitude;
    savedRadiusData.current = radiusData.current;

    const skuAttribute = document.querySelector('[data-sku]').getAttribute('data-sku');
    const url = `https://inventory-lookup-service.wndsr.io/store_inventory_lookup?lat=${latitude}&lng=${longitude}&sku=${skuAttribute}&range=${radiusData.current}`;
    // const url = `https://inventory-lookup-service.wndsr.dev/store_inventory_lookup?lat=${latitude}&lng=${longitude}&sku=${skuAttribute}`;

    const fetchInventoryService = fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        searchedOnce.current = true;

        const setSuccessStates = () => {
          setStoreList(data);
          setSuccessfulResponse(true);
          setFirstTimeOpened(true);
        };

        if (isGeoLocation && firstTimeOpened) {
          setIsLoading(false);
          setSuccessStates();
        } else {
          setTimeout(() => {
            setIsLoading(false);
            setSuccessStates();
          }, 700);
        }

        if (data.length === 0) {
          clearLocalStorage();
        }

        if (window.innerWidth <= 767 && data.length > 0) {
          setDynamicHeight();
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setFormError(true);
        clearLocalStorage();
        console.error('Error:', error);
      });
  };

  const showLocation = (position) => {
    storedLatitude.current = position.coords.latitude;
    storedLongitude.current = position.coords.longitude;
    window.localStorage.setItem(
      'userLatLong',
      JSON.stringify({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      }),
    );
    setFirstTimeOpened(true);

    //  middleware request that sends coordinates + radius
    fetchStores(position.coords.latitude, position.coords.longitude, true);
  };

  const blockLocation = (error) => {
    console.log(error);
    setIsLoading(false);
  };

  const getLatLong = () => {
    setSuccessfulResponse(false);
    setFormError(false);
    setIsLoading(true);
    setErrorMessage('');

    navigator.geolocation.getCurrentPosition(showLocation, blockLocation);
  };

  // Update store list if user updates SKU (color/size)
  document.addEventListener('variantChange', (event) => {
    event.stopImmediatePropagation();

    const modalOpen = document.querySelector('.StoreInventoryModal__container');
    // console.log('variant updated');

    if (!modalOpen && searchedOnce.current) {
      setSortedStoreList([]);
      setNumberOfStores(0);
      setSuccessfulResponse(false);
      window.localStorage.removeItem('userLatLong');
      window.localStorage.removeItem('userAddress');
      return;
    }

    if (storedLatitude.current && storedLongitude.current) {
      fetchStores(storedLatitude.current, storedLongitude.current, false);
    }
  });

  useEffect(() => {
    let latLong = window.localStorage.getItem('userLatLong');
    let address = window.localStorage.getItem('userAddress');

    if (address) {
      setAddressData(address);
    }

    if (latLong && !firstTimeOpened) {
      let latLongObj = JSON.parse(latLong);
      fetchStores(latLongObj.latitude, latLongObj.longitude, false);
    }
  }, []);

  return (
    <div>
      {modalIsOpen && (
        <div className="StoreInventoryModal__container">
          {isLoading && (
            <div className="StoreInventoryModal__loader">
              <img
                src="https://cdn.shopify.com/s/files/1/0070/8853/7651/files/Windsor_LoadingHeart.gif?63611"
                alt="loading"
              />
            </div>
          )}
          {/* close icon */}
          <div className="CloseIcon" onClick={closeModal}>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          {/* end close icon */}
          <p className="StoreInventoryModal__title">Check Windsor Store Locations</p>
          <p className="StoreInventoryModal__error">{errorMessage}</p>
          <form className="StoreInventoryModal__form" onSubmit={submitSearch}>
            <div className="StoreInventoryModal__row">
              <input
                className={`StoreInventoryModal__form-search ${
                  formError ? 'StoreInventoryModal__form-search--error' : ''
                }`}
                placeholder="ZIP code or City & State"
                value={addressData}
                onChange={(e) => {
                  setAddressData(e.target.value);
                }}
              />
              <select
                className="StoreInventoryModal__form-radius"
                defaultValue={window.localStorage.getItem('userLatLong') ? savedRadiusData.current : radiusData.current}
                onChange={(e) => {
                  radiusData.current = e.target.value;
                }}
              >
                <option value="25">25 miles</option>
                <option value="50">50 miles</option>
                <option value="100">100 miles</option>
                <option value="200">200 miles</option>
              </select>
              <button className="Button Button--primary" onClick={getGeoLocation} type="submit">
                Go
              </button>
            </div>
            <div className="StoreInventoryModal__row">
              <span className="StoreInventoryModal__link-text" onClick={getLatLong}>
                Use Current Location
              </span>
            </div>
          </form>
          {numberOfStores >= 0 && sortedStoreList && sortedStoreList.length > 0 && (
            <div className="StoreInventoryModal__disclaimer-bar">
              Product availability changes frequently and isn’t guaranteed.
            </div>
          )}
          {sortedStoreList && sortedStoreList.length > 0 && (
            <div className="StoreInventoryModal__location-count">{numberOfStores} Locations with this item</div>
          )}

          {successfulResponse && sortedStoreList && sortedStoreList.length <= 0 && (
            <div className="StoreInventoryModal__error-unavailable">
              Oh no! This style isn’t available in any nearby stores. Try expanding your distance for better results.
            </div>
          )}

          {sortedStoreList && sortedStoreList.length > 0 && (
            <div
              className={`StoreInventoryModal__stores ${
                loadMoreClicked ? 'StoreInventoryModal__stores--expanded' : ''
              }`}
            >
              {sortedStoreList.map((store, i) => {
                if (i < 3) {
                  return (
                    <div
                      key={`${i}a`}
                      className={`StoreInventoryList ${
                        !loadMoreClicked && i === 2 ? 'StoreInventoryList__hide-border' : ''
                      }`}
                    >
                      <StoreInventoryList
                        lastIndex={sortedStoreList.length - 1}
                        index={i}
                        buttonClicked={loadMoreClicked}
                        key={i}
                        store={store}
                      />
                    </div>
                  );
                } else if (loadMoreClicked) {
                  return (
                    <div
                      key={`${i}b`}
                      className={`StoreInventoryList ${
                        i === sortedStoreList.length - 1 ? 'StoreInventoryList__hide-border' : ''
                      }`}
                    >
                      <StoreInventoryList
                        lastIndex={sortedStoreList.length - 1}
                        index={i}
                        buttonClicked={true}
                        key={store.store_name}
                        store={store}
                      />
                    </div>
                  );
                }
              })}
              {!loadMoreClicked && sortedStoreList.length > 3 && (
                <button className="Button Button--secondary StoreInventoryModal__load-button" onClick={clickLoadMore}>
                  Load More Locations
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const renderInventoryModal = (el) => {
  // get product json by closest element clicked
  ReactDOM.render(<StoreModal />, el);
};

export default () => {
  const el = document.querySelector('[data-store-inventory-modal]');
  if (el) {
    renderInventoryModal(el);
  }
};

// const staticData = [
//   {
//     code: '0156',
//     store_name: '156 - Natick Mall',
//     address: {
//       address_line_1: '1245 Worcester St #1196',
//       address_line_2: null,
//       province: null,
//       state: 'MA',
//       zip_code: '01760',
//       city: 'Natick',
//       country_code: 'US',
//       latitude: 42.300906,
//       longitude: -71.382688,
//     },
//     phone_number: '508-465-8410',
//     business_hours: [],
//     distance: 32.69982233008805,
//     quantity: 0,
//   },
//   {
//     code: '0138',
//     store_name: '138 - South Shore Plaza',
//     address: {
//       address_line_1: '250 Granite Street Space #2003',
//       address_line_2: null,
//       province: null,
//       state: 'MA',
//       zip_code: '02184',
//       city: 'Braintree',
//       country_code: 'US',
//       latitude: 42.220902,
//       longitude: -71.02352,
//     },
//     phone_number: '781-428-4058',
//     business_hours: [],
//     distance: 33.99635558821084,
//     quantity: 0,
//   },
//   {
//     code: '0106',
//     store_name: '106 - Buckland Hills Mall',
//     address: {
//       address_line_1: '194 Buckland Hills Dr #1135',
//       address_line_2: null,
//       province: null,
//       state: 'CT',
//       zip_code: '06042',
//       city: 'Manchester',
//       country_code: 'US',
//       latitude: 41.807097,
//       longitude: -72.546064,
//     },
//     phone_number: '860-967-3608',
//     business_hours: [],
//     distance: 57.83317996000673,
//     quantity: 0,
//   },
//   {
//     code: '0167',
//     store_name: '167 - The Mall at Rockingham Park',
//     address: {
//       address_line_1: '79 Rockingham Park Blvd, #E217A',
//       address_line_2: null,
//       province: null,
//       state: 'NH',
//       zip_code: '03079',
//       city: 'Salem',
//       country_code: 'US',
//       latitude: 42.767803,
//       longitude: -71.224623,
//     },
//     phone_number: '603-685-3455',
//     business_hours: [],
//     distance: 65.68232820767686,
//     quantity: 0,
//   },
//   {
//     code: '0160',
//     store_name: '160 - Holyoke Mall',
//     address: {
//       address_line_1: '50 Holyoke St #F383',
//       address_line_2: null,
//       province: null,
//       state: 'MA',
//       zip_code: '01040',
//       city: 'Holyoke',
//       country_code: 'US',
//       latitude: 42.167805,
//       longitude: -72.641174,
//     },
//     phone_number: '413-561-0290',
//     business_hours: [],
//     distance: 66.78193281921232,
//     quantity: 0,
//   },
//   {
//     code: '0032',
//     store_name: '32 - Meriden Mall',
//     address: {
//       address_line_1: '470 Lewis Ave #2004',
//       address_line_2: null,
//       province: null,
//       state: 'CT',
//       zip_code: '06451',
//       city: 'Meriden',
//       country_code: 'US',
//       latitude: 41.551205,
//       longitude: -72.809009,
//     },
//     phone_number: '203-580-3090',
//     business_hours: [],
//     distance: 74.02007799285444,
//     quantity: 0,
//   },
//   {
//     code: '0139',
//     store_name: '139 - Mall of New Hampshire',
//     address: {
//       address_line_1: '1500 S Willow St. #S163',
//       address_line_2: null,
//       province: null,
//       state: 'NH',
//       zip_code: '03103',
//       city: 'Manchester',
//       country_code: 'US',
//       latitude: 42.956761,
//       longitude: -71.435762,
//     },
//     phone_number: '603-782-4838',
//     business_hours: [],
//     distance: 77.9511940878128,
//     quantity: 0,
//   },
//   {
//     code: '0033',
//     store_name: '33 - Connecticut Post',
//     address: {
//       address_line_1: '1201 Post Road Space# 1010',
//       address_line_2: null,
//       province: null,
//       state: 'CT',
//       zip_code: '06460',
//       city: 'Milford',
//       country_code: 'US',
//       latitude: 41.235812,
//       longitude: -73.035027,
//     },
//     phone_number: '203-647-1550',
//     business_hours: [],
//     distance: 92.8779018010024,
//     quantity: 1,
//   },
//   {
//     code: '0038',
//     store_name: '38 - Westfield Mall',
//     address: {
//       address_line_1: '5065 Main St Space #2111',
//       address_line_2: null,
//       province: null,
//       state: 'CT',
//       zip_code: '06611',
//       city: 'Trumbull',
//       country_code: 'US',
//       latitude: 41.229966,
//       longitude: -73.220028,
//     },
//     phone_number: '203-638-1090',
//     business_hours: [],
//     distance: 101.7204406567685,
//     quantity: 0,
//   },
//   {
//     code: '0109',
//     store_name: '109 - Westfield South Shore',
//     address: {
//       address_line_1: '1701 Sunrise Hwy G3',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '11706',
//       city: 'Bay Shore',
//       country_code: 'US',
//       latitude: 40.705138,
//       longitude: -73.243004,
//     },
//     phone_number: '631-629-8897',
//     business_hours: [],
//     distance: 122.29114756262662,
//     quantity: 0,
//   },
//   {
//     code: '0108',
//     store_name: '108 - Westfield Sunrise Mall',
//     address: {
//       address_line_1: '1 Sunrise Mall #2250',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '11758',
//       city: 'Massapequa',
//       country_code: 'US',
//       latitude: 40.682644,
//       longitude: -73.43455,
//     },
//     phone_number: '516-665-0498',
//     business_hours: [],
//     distance: 131.07750476694622,
//     quantity: 0,
//   },
//   {
//     code: '0169',
//     store_name: '169 - Crossgates Mall',
//     address: {
//       address_line_1: '1 Crossgates Mall Rd, #B-105',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '12203',
//       city: 'Albany',
//       country_code: 'US',
//       latitude: 42.688836,
//       longitude: -73.849017,
//     },
//     phone_number: '518-556-6469',
//     business_hours: [],
//     distance: 137.54125714689715,
//     quantity: 0,
//   },
//   {
//     code: '0157',
//     store_name: '157 - Palisades Center',
//     address: {
//       address_line_1: '1000 Palisades Center Dr #C201',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '10994',
//       city: 'West Nyack',
//       country_code: 'US',
//       latitude: 41.09854,
//       longitude: -73.959382,
//     },
//     phone_number: '845-512-5007',
//     business_hours: [],
//     distance: 140.65859165540277,
//     quantity: 0,
//   },
//   {
//     code: '0115',
//     store_name: '115 - Mall at Bay Plaza',
//     address: {
//       address_line_1: '200 Baychester Ave 148-149',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '10475',
//       city: 'Bronx',
//       country_code: 'US',
//       latitude: 40.865733,
//       longitude: -73.83003,
//     },
//     phone_number: '718-618-4227',
//     business_hours: [],
//     distance: 141.44906730686685,
//     quantity: 0,
//   },
//   {
//     code: '0170',
//     store_name: '170 - Galleria at Crystal Run',
//     address: {
//       address_line_1: '1 Galleria Dr, Middletown, #A210',
//       address_line_2: null,
//       province: null,
//       state: 'NY',
//       zip_code: '10941',
//       city: 'Middletown',
//       country_code: 'US',
//       latitude: 41.452854,
//       longitude: -74.370774,
//     },
//     phone_number: '845-208-9700',
//     business_hours: [],
//     distance: 154.38363395240896,
//     quantity: 0,
//   },
// ];
